import { embedDashboard } from "@superset-ui/embedded-sdk";
import Vue from "vue";
import { Action } from "vuex-class";
import { Component, Prop, Watch } from "vue-property-decorator";
import { ReportServices } from "../../scripts/ah.mb.report-services";
import { modelServices } from "../../scripts/ah.mb.ui.model-services";
import { ModelNotifier } from "../../scripts/model-notifier";
import { FetchWrapper } from "../../infrastructure/fetch-wrapper";
import { IDashboardInfo } from "../dashboard-list/dashboard-list";
import { bootbox } from "../../infrastructure/bootbox-shim";

//import { embedDashboard } from 'amazon-quicksight-embedding-sdk';

const namespace: string = "profile";


interface IEmbeddedDashboardInfo {
    embedId: string;
    hostDomain: string;
}

@Component
export default class EmbeddedDashboard extends Vue {

    @Prop()
    dashboardId: string;

    @Action("setCurrentModelId", { namespace: namespace }) setCurrentModelId: any;

    // Model change observer
    private modelObserver = new ModelNotifier();

    modelServices = new modelServices(this.modelObserver);
    reportServices = new ReportServices(this.modelObserver);

    @Watch("$route.params.dashboardId")
    routeModeIdChanged(newVal) {
        this.loadModel();
    }

    loadModel() {
        //// Add page to recent list
        if (this.dashboardId) {
            //    const recentItemsStore = new RecentlyVisitedPages(8);
            //    recentItemsStore.stack.add(
            //        {
            //            modelId: this.modelId,
            //            pageType: PageType.Dashboard,
            //            name: this.modelId + " | Embedded Dashboard",
            //            visitedDate: new Date()
            //        });

            this.loadDashboard(this.dashboardId);
        }

    }

    loadDashboard(dashboardId: string) {

        FetchWrapper.fetch(`/api/1.0/query/getEmbeddedDashboardInfo?dashboardId=${dashboardId}`,
            { method: "get" })
            .then(response => response.json())
            .then((value: IEmbeddedDashboardInfo) => { 

                this.embedDashboard(dashboardId, value.embedId, value.hostDomain);
    });
    }

    private embedDashboard(dashboardId: string, embedId: string, hostDomain: string): Promise<any>
    {
        return FetchWrapper.fetch(`/api/1.0/query/getDashboardGuestToken?dashboardId=${embedId}`, { method: "get" })
            .then(response => response.text())
            .then(token => {

                embedDashboard({
                    id: embedId, // given by the Superset embedding UI
                    supersetDomain: hostDomain, //  "https://superset.arrowheadmodeling.com",
                    mountPoint: document.getElementById("dashboardContainer"), // any html element that can contain an iframe
                    fetchGuestToken: () => Promise.resolve(token), //this.getSuperserGuestToken, // fetchGuestTokenFromBackend(),
                    dashboardUiConfig: { hideTitle: true }, // dashboard UI config: hideTitle, hideTab, hideChartControls (optional)
                })

                // Get the title so we can dispay it in the header

                FetchWrapper.fetch(`/api/1.0/query/getDashboardInfo?dashboardId=${dashboardId}`, { method: "get" })
                    .then(response => response.json())
                    .then((value: IDashboardInfo) => this.setCurrentModelId(value.name));

            });

}


    mounted() {
        this.loadModel();

    }

    tabChanged(tabName: "tools" | "viewer") {

    }


}



// WEBPACK FOOTER //
// ./ClientApp/components/embedded-dashboard/embedded-dashboard.ts